import {useEffect} from 'react';
import {useValidSignThemeAsRoot} from '@ValidSignBV/theme-switcher';
import {selectTheme} from '@components/appSlice';
import {selectDefaultBrand} from '@components/SignerUi/signerUiSlice';
import {useSelector} from 'react-redux';
import {useCurrentRoute} from '@hooks/useCurrentRoute';
import {THEMES} from '../../constants';
import {getAppVariables} from './senderTheme/appCssVars';
import {getBrandHostAppVariables} from './signerTheme';

const SENDER_STYLE_TAG_ID = 'sender-ui-css-vars';
const SIGNER_STYLE_TAG_ID = 'signer-ui-css-vars';

/**
 * Unified branding hook that manages both sender and signer theme CSS variables.
 * Applies sender layout variables on all routes, and signer brand color overrides
 * only when on a signer route.
 */
export function useBranding() {
    const theme = useSelector(selectTheme) || THEMES.LIGHT;
    const currentRoute = useCurrentRoute();
    const isSignerRoute = currentRoute?.isSignerRoute || false;
    const signerBrand = useSelector(selectDefaultBrand);

    useEffect(() => {
        if (typeof document !== 'undefined') {
            document.documentElement.setAttribute('data-theme', theme);
        }
    }, [theme]);

    useValidSignThemeAsRoot({
        theme,
        styleTagId: SENDER_STYLE_TAG_ID,
        hostAppVariables: getAppVariables()
    });

    const signerHostAppVariables = isSignerRoute ? getBrandHostAppVariables(signerBrand) : {};

    useValidSignThemeAsRoot({
        theme,
        styleTagId: SIGNER_STYLE_TAG_ID,
        hostAppVariables: signerHostAppVariables
    });

    useEffect(() => () => {
        const styleTag = document.getElementById(SIGNER_STYLE_TAG_ID);
        if (styleTag) {
            styleTag.remove();
        }
    }, []);
}
